<template>
    <div class="h-rest">
        <div class="background-grey"></div>
        <div class="toolbar">
            <ViewMode></ViewMode>
        </div>
        <MapCt v-if="viewModeType === 'map'"></MapCt>
        <BarChartCt v-if="viewModeType === 'bar-chart'"></BarChartCt>
        <TableCt v-if="(stepIndex == 1) && (viewModeType == 'table')"></TableCt>
        <GeographicSustainTableCt v-if="(stepIndex == 2) && (viewModeType == 'table')"></GeographicSustainTableCt>
        <GeographicRespondTableCt v-if="(stepIndex == 3) && (viewModeType == 'table')"></GeographicRespondTableCt>
        <PieChartCt v-if="viewModeType === 'pie-chart'"></PieChartCt>
        <HydroCt v-if="viewModeType === 'hydrograph'"></HydroCt>
        

        <div class="left-toolbar">
            <div v-if="view.viewColors" class="colorButtonBar">
                <div class="color-item"
                    v-for="viewColor in view.viewColors"
                    :key="viewColor"
                    @click="assessment.setViewColor(viewColor)"
                    :title="'Show ' + viewColor + ' water footprint'"
                    :class="{
                        'active-green': assessment.viewColor === 'green' && viewColor === 'green',
                        'active-grey': assessment.viewColor === 'grey' && viewColor === 'grey',
                        'active-blue': assessment.viewColor === 'blue' && viewColor === 'blue',
                        'active-total': assessment.viewColor === 'total'  && viewColor === 'total'
                    }"
                >{{viewColor}}</div>
            </div>
            <div @click="openCropDialog()"
                 v-bind:class="{ 'crops-open-ct': true, 'open': isOpenCropsDialog }"
                 v-if="view.hasCrops"
                 title="Select a crop or sector"
            >
                <img src="../assets/img/crop.svg" height="35" alt  />
            </div>
        </div>

        <modal name="crops-modal" :width="650" :height="'auto'">
            <Crop v-on:close="closeCropDialog()"></Crop>
        </modal>
    </div>
</template>

<script>
import { assessment } from "@/services/assessment-model.js";
import ViewMode from "@/components/shared/ViewMode.vue";
import TableCt from "@/views/TableCt.vue";
import GeographicSustainTableCt from "@/views/GeographicSustainTableCt.vue";
import GeographicRespondTableCt from "@/views/GeographicRespondTableCt.vue";
import BarChartCt from "@/views/BarChartCt.vue";
import PieChartCt from "@/views/PieChartCt.vue";
import HydroCt from "@/views/HydroCt.vue";
import MapCt from "@/views/MapCt.vue";
import Crop from "@/components/modal/Crop.vue";

export default {
    name: 'Main',
    data() {
        return {
            isOpenCropsDialog: false,
            assessment: assessment
        }
    },
    components: {
        ViewMode,
        MapCt,
        BarChartCt,
        PieChartCt,
        TableCt,
        GeographicSustainTableCt,
        GeographicRespondTableCt,
        Crop,
        HydroCt
    },
    computed: {
        stepIndex: function() {
            return assessment.step.index;
        },
        viewModeType: function() {
            return assessment.viewType.name;
        },
        view: function() {
            return assessment.assessmentType.steps[assessment.step.index].views.find(view => view.viewType == assessment.viewType);
        }
    },
    methods: {
        openCropDialog: function() {
            this.isOpenCropsDialog = true;
            this.$modal.show('crops-modal');
        },
        closeCropDialog: function() {
            this.isOpenCropsDialog = false;
            this.$modal.hide('crops-modal');
        }
    }
}
</script>

<style lang="scss" scoped>
.toolbar {
    z-index: 10;
    position: absolute;
    right: 0;
    top: 100px;
}

.left-toolbar {
    z-index: 10;
    position: absolute;
    left: 0;
    top: 100px;
}
.colorButtonBar {
    overflow: hidden;
    background-color: grey;
    border: 1px sold #707070;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #edebe5;
    margin-bottom: 20px;
    text-transform: capitalize; 
    .color-item {
        cursor: pointer;
        padding-bottom: 15px;
        padding-top: 15px;
        padding-left: 15px;
        padding-right: 15px;
        &.active {
            background-color: white;
        }
    }
}

.crops-open-ct {
    background-color: grey;
    border: 1px sold #707070;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #edebe5;
    cursor: pointer;
    padding: 10px 15px;
    &.open {
        background-color: white;
    }
}
.active-green {
    background-color: #6eb3a2;
    color: white;
}

.active-blue {
    background-color: #349bd1;
    color: white;
}

.active-grey {
    background-color: #212529;
    color: white;
}

.active-total {
    background-color: #e45a00;
    color: white;
}

.background-grey {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    background: #cccccc; /* Old browsers */
    background: -moz-linear-gradient(top,  #cccccc 0%, #ececec 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  #cccccc 0%,#ececec 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  #cccccc 0%,#ececec 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#cccccc', endColorstr='#ececec',GradientType=0 ); /* IE6-9 */
}
.fade-enter {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s ease-in-out;
}

.fade-leave-to {
    opacity: 0;
}
</style>


